import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VApp,[_c('allianz-reith-app-bar',{attrs:{"app":""}}),_c('allianz-reith-navigation-drawer'),_c(VMain,[_c(VContainer,{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('allianz-reith-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }